import React from 'react';
import { TrimoraLanding } from './pages/TrimoraLanding';
export function App() {
  return <TrimoraLanding data-id="element-0" />;
}